/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordDto } from '../../models/change-password-dto';
import { LoginStoreResponse } from '../../models/login-store-response';

export interface PatchChangePassword$Params {
      body: ChangePasswordDto
}

export function patchChangePassword(http: HttpClient, rootUrl: string, params: PatchChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStoreResponse>> {
  const rb = new RequestBuilder(rootUrl, patchChangePassword.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginStoreResponse>;
    })
  );
}

patchChangePassword.PATH = '/v1/login';
